const AD_SERVER_DESC = [
  `Some significant issues are blocking you from achieving your revenue potential.
  This score is related to your Google Ad Manager setup. We verify your tags and any other misconfiguration.
  Check the score cards below to see more details about it and discover how to fix it.`,

  `We still have a lot to do with your website!
  This score is related to your Google Ad Manager setup. We verify your tags and any other misconfiguration.
  Check the score cards below to see more details about it and discover how to fix it.`,

  `You did a good job in your setup, but there are some errors to fix. 
  This score is related to your Google Ad Manager setup. We verify your tags and any other misconfiguration.
  Check the score cards below to see more details about it and discover how to fix it.`,

  `You did an excellent job in your setup.
  This score is related to your Google Ad Manager setup. We verify your tags and any other misconfiguration.
  Check your score frequently when you have to do any other significant changes, so it doesn't negatively affect your website's overall grade.`,
];

const POLICY_DESC = [
  `Some significant issues are blocking you from achieving your revenue potential.
  This score shows you the percentage of your ad inventory that complies with the Google Policy rules. 
  Check the score cards below to see more details about it and discover how to fix it.`,

  `We still have a lot to do with your website!
  This score shows you the percentage of your ad inventory that complies with the Google Policy rules. 
  Check the score cards below to see more details about it and discover how to fix it.`,

  `You did a good job with your content, but there are some errors to fix. 
  This score shows you the percentage of your ad inventory that complies with the Google Policy rules. 
  Check the score cards below to see more details about it and discover how to fix it.`,

  `You did an excellent job with your content. 
  This score shows you the percentage of your ad inventory that complies with the Google Policy rules. 
  Check your score frequently when you have to do any other significant changes, so it doesn't negatively affect your website's overall grade.`,
];

const BIDDING_DESC = [
  `Some significant issues are blocking you from achieving your revenue potential.
  This score is related to your Header Bidding setup. 
  Check the score cards below to see more details about it and discover how to fix it.`,

  `You still have some work to do in your Header Bidding setup. 
  This score is related to your Header Bidding setup. 
  Check the score cards below to see more details about it and discover how to fix it.`,

  `You did a good job in your Header Bidding setup, but there are some errors to fix. 
  This score is related to your Header Bidding setup. 
  Check the score cards below to see more details about it and discover how to fix it.`,

  `You did an excellent job in your Header Bidding setup. 
  This score is related to your Header Bidding setup. 
  Check your score frequently when you have to do any other significant changes, so it doesn't negatively affect your website's overall grade.`,
];

export const FULLVIEW_DESC_MAP = {
  "Policy Violations": POLICY_DESC,
  "Header Bidding": BIDDING_DESC,
  "GAM Ad Setup": AD_SERVER_DESC
}


const AD_SERVER_MESSAGES = [
  "We couldn't find the Google Ad Manager in your account.",
  "There's room for improvement in your Google Ad Manager.",
  "Your Google Ad Manager is good, but we still found some issues.",
  "Your Google Ad Manager is on point and doesn't need improvement.",
];

const POLICY_MESSAGES = [
  "We've found many Google policy violations on your site. Make sure to fix them right away because your ad revenue accounts are at risk!",
  "Uh oh! We've found several Google policy violations. Check out the recommendations to tidy that up.",
  "Some of your site doesn't follow Google policies.",
  "Great job on following Google policies!",
];

const BIDDING_MESSAGES = [
  "We've found big issues in your Header Bidding Setup.",
  "There's room for improvement in your Header Bidding Setup.",
  "Your Header Bidding Setup is good, but we still have found some issues.",
  "Your Header Bidding Setup is on point and doesn't need improvement.",
];

export const SUMMARY_MESSAGES_MAP = {
  "Policy Violations": POLICY_MESSAGES,
  "Header Bidding": BIDDING_MESSAGES,
  "GAM Ad Setup": AD_SERVER_MESSAGES
}

export const HERO_MESSAGES = {
  'excellent': {
    title: 'You nailed it!',
    subtitle: 'We analyzed your website, and you are doing an excellent job.',
    lines: ['Now, it\'s essential to check your website score frequently and not to leave money on the table.',
    'Check what we found about your ad inventory in the scorecards below to maintain your excellent grade.']
  },
  'good': {
    title: 'You are doing a good job but we can do better!',
    subtitle: 'We analyzed your website and we can fix some issues to turn your website into a revenue machine.',
    lines: ['Check what we found about your ad inventory in the scorecards below to improve your grade.']
  },
  'almost': {
    title: 'We still have a lot to do with your website!',
    subtitle: 'We analyzed your website, and we still found many issues. Fix them all, and turn your website into a revenue machine.',
    lines: ['Check what we found about your ad inventory in the scorecards below to improve your grade.']
  },
  'bad': {
    title: 'Ops! We found some big issues.',
    subtitle: 'Now, let\'s fix all of them to turn your website into a revenue machine.',
    lines: ['Check what we found out about your ad inventory in the scorecards below to improve your grade.']
  }
}

export const CATCHY_PHRASES = {
  'GAM Ad Setup': 'Cut your ad revenue leaks by fixing your ad server setup!',
  'Policy Violations': 'Protect your ad revenue accounts by fixing those policy violations!',
  'Header Bidding': 'Get more revenue from your ad impressions with an optimal header bid setup!',
}

export const SIGN_UP_MESSAGES = [
  {
    'title': 'See all issues and opportunities we found in your GAM Ad Setup.',
    'message': 'When you sign up for a PubGuru FREE ACCOUNT, you have real-time notifications about the tags you need to fix or any other misconfiguration.',
  },
  {
    'title': 'See all issues and opportunities we found in your Header Bidding Setup.',
    'message': 'When you sign up for a PubGuru FREE ACCOUNT, you have real-time notifications about which ad units are without PID, with missing requests, or any other configuration error.',
  },
  {
    'title': 'See all content in your Ad Inventory that doesn\'t comply with the Google Policy rules.',
    'message': 'When you sign up for a PubGuru FREE ACCOUNT, you have real-time notifications about the ads Google might consider controversial and that are hidden or overlapped.',
  },
  {
    'title': 'See all issues and opportunities we found in your Ad Inventory.',
    'message': 'When you sign up for a PubGuru FREE ACCOUNT, you have real-time notifications about your tags, any misconfiguration, and alerts of ads that don\'t comply with Google\'s policy.',
  },
];
